module.exports = __webpack_public_path__ + "static/img/yingyanbaojian.9128588.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yingyanbaojian.png
// module id = FV+L
// module chunks = 0